<template>
  <div id="entryLog">
    <!-- 头部 -->
    <div class="head">
      <div class="head_left">
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </div>
      <div class="head_right">
        <el-input
          v-model="entryLog_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
          v-grantShow="$store.state.SysGrant.GetAllAccountLog"
        >
          <template #append>
            <el-button icon="Search" @click="entryLogGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="entryLogData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
    >
      <el-table-column prop="id" label="ID" min-width="80"> </el-table-column>
      <el-table-column label="登录账号" min-width="150">
        <template #default="scope">
          {{ scope.row.user.name || "--" }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="登录地址" min-width="150">
        <template #default="scope">
          {{ scope.row.geo || "--" }}
        </template>
      </el-table-column> -->
      <el-table-column label="登录地址" min-width="150">
        <template #default="scope">
          <div>{{ scope.row.geo || "--" }}</div>
          <div>{{ scope.row.ip || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="登录状态" min-width="150">
        <template #default="scope">
          <el-tag :type="scope.row.state ? 'success' : 'danger'">{{
            scope.row.state ? "成功" : "失败"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="设备信息" min-width="150">
        <template #default="scope">
          <div>{{ scope.row.platform.os_name + scope.row.platform.os_ver || "--" }}</div>
          <div>{{ scope.row.platform.browser_name || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="登录时间" min-width="165">
        <template #default="scope">
          <template v-if="scope.row.time">
            {{ $moment(scope.row.time * 1000).format("yyyy-MM-DD HH:mm:ss") }}
          </template>
          <template v-else> -- </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination
      background
      :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
      :page-sizes="[10, 20, 100, 200, 500, 1000]"
      layout="prev,pager,next,sizes,slot"
      v-model:current-page="entryLog_req.page"
      v-model:page-size="entryLog_req.page_max"
      :total="tableCount"
    >
      <div class="statistical">
        每页<b style="color: #ff0000">{{ entryLog_req.page_max }}</b
        >条/共<b style="color: #059669">{{ tableCount }}</b> 条数据
      </div>
    </el-pagination>
  </div>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//门店类型请求参数
let entryLog_req = reactive({
  value: "",
  page: 1,
  page_max: 10,
});
//搜索类型
let selectData = {
  1: {
    label: "账号",
    value: 1,
    key: "tel",
  },
};
//搜索id
let selectId = ref(1);
//门店类型数据
let entryLogData = ref([]);
//门店类型总数
let tableCount = ref(0);
//时间范围
let dateValue = ref("");
//监听请求参数变化事件
watch(
  [() => entryLog_req.value, () => entryLog_req.page_max, () => dateValue.value],
  async (newValue, oldValue) => {
    if (entryLog_req.page == 1) {
      entryLogGet();
    } else {
      entryLog_req.page = 1;
    }
  }
);
watch([() => entryLog_req.page], async (newValue, oldValue) => {
  entryLogGet();
});
//页面渲染事件
onMounted(() => {
  entryLogGet();
});
//门店类型获取
function entryLogGet() {
  let req = {
    page: entryLog_req.page,
    page_max: entryLog_req.page_max,
    starttime:dateValue.value?Math.ceil(dateValue.value[0].getTime()/1000):undefined,
    endtime:dateValue.value?Math.ceil(dateValue.value[1].getTime()/1000):undefined
  };
  req[selectData[selectId.value].key] = entryLog_req.value;
  proxy.$http
    .get("webapi/account_login_mgr?item=list", {
      params: {
        ...req,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        tableCount.value = res.data.count;
        res.data.list.forEach((item) => {
          item.user = res.data.users.find((item2) => item2.id == item.uid);
          item.platform = res.data.platforms.find(
            (item2) => item2.id == item.pid
          );
        });
        entryLogData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/log/entryLog.scss";
</style>